import logo from './logo.svg';
import './App.css';
import React from 'react';
import HomePage from './home';



const App = () => {
  return (
    <HomePage/>
  );
}

export default App;
